import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export interface OtcContractModalsProps {
  unstageModalId: string | undefined;
  deleteModalId: string | undefined;
  setUnstageModalId: (id: string | undefined) => void;
  setDeleteModalId: (id: string | undefined) => void;
  isUnstaging: boolean;
  isDeleting: boolean;
  onUnstage: ({ id }: { id: string }) => Promise<void>;
  onDelete: ({ id }: { id: string }) => Promise<void>;
}

export function OtcContractModals({
  unstageModalId,
  deleteModalId,
  setUnstageModalId,
  setDeleteModalId,
  isUnstaging,
  isDeleting,
  onUnstage,
  onDelete,
}: OtcContractModalsProps) {
  return (
    <>
      {/* Unstage Confirmation Modal */}
      <Dialog
        open={!!unstageModalId}
        onOpenChange={(status) => {
          if (!status) {
            setUnstageModalId(undefined);
          }
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Are you sure you want to approve this contract?</DialogTitle>
          </DialogHeader>

          <form
            className="flex flex-col gap-4"
            onSubmit={(e) => {
              if (e?.preventDefault) {
                e.preventDefault();
              }
              return onUnstage({ id: unstageModalId! });
            }}
          >
            <Button type="submit" disabled={isUnstaging}>
              {isUnstaging ? "Processing..." : "Confirm"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={!!deleteModalId}
        onOpenChange={(status) => {
          if (!status) {
            setDeleteModalId(undefined);
          }
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              Are you sure you want to delete this staged contract?
            </DialogTitle>
          </DialogHeader>

          <form
            className="flex flex-col gap-4"
            onSubmit={(e) => {
              if (e?.preventDefault) {
                e.preventDefault();
              }
              return onDelete({ id: deleteModalId! });
            }}
          >
            <Button type="submit" disabled={isDeleting}>
              {isDeleting ? "Processing..." : "Confirm"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

